import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export function initFaro() {
  initializeFaro({
    url: 'https://faro-collector-prod-us-east-0.grafana.net/collect/7ab11d7188e1f49da2995c0c4787bdad',
    app: {
      name: 'ATMS',
      version: '1.0.0',
      environment: 'production',
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
  });
}
